import { useState } from 'react'
import { getFirestore, collection, addDoc, serverTimestamp } from 'firebase/firestore'
import { app } from '../../firebase'
import toast from 'react-hot-toast'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'

function LandingContact () {
  const db = getFirestore(app)
  const [contactForm, setContactForm] = useState({
    name: '',
    email: '',
    company: '',
    message: ''
  })
  const [submitted, setSubmitted] = useState(false)
  const [submitting, setSubmitting] = useState(false)

  const handleSubmit = async e => {
    e.preventDefault()
    setSubmitting(true)

    try {
      const contactRef = collection(db, 'contactRequests')
      await addDoc(contactRef, {
        name: contactForm.name,
        email: contactForm.email,
        company: contactForm.company,
        message: contactForm.message,
        status: 'new',
        createdAt: serverTimestamp(),
        source: 'landing_page'
      })

      setSubmitted(true)
      toast.success('Vielen Dank! Wir melden uns innerhalb von 24 Stunden.')

      setTimeout(() => {
        setSubmitted(false)
        setContactForm({ name: '', email: '', company: '', message: '' })
      }, 3000)
    } catch (error) {
      console.error('Error submitting contact form:', error)
      toast.error('Fehler beim Senden. Bitte versuchen Sie es erneut.')
    } finally {
      setSubmitting(false)
    }
  }

  const handleChange = e => {
    setContactForm({
      ...contactForm,
      [e.target.name]: e.target.value
    })
  }

  return (
    <section className='lp-contact-section' id='contact'>
      <div className='lp-section-content'>
        <div className='lp-contact-wrapper'>
          <div className='lp-contact-info'>
            <h2>Bereit, Zeit und Kosten zu sparen?</h2>
            <p>
              Vereinbaren Sie jetzt eine kostenlose Demo und erleben Sie, wie
              Engineers Knowledge Base Ihren Service-Alltag revolutioniert.
            </p>
            <div className='lp-contact-benefits'>
              <div className='lp-contact-benefit'>
                <span className='lp-check-icon'>
                  <CheckCircleIcon sx={{ fontSize: 24 }} />
                </span>
                <span>Persönliche Demo-Session (30 Min)</span>
              </div>
              <div className='lp-contact-benefit'>
                <span className='lp-check-icon'>
                  <CheckCircleIcon sx={{ fontSize: 24 }} />
                </span>
                <span>Individuelle Beratung für Ihre Anforderungen</span>
              </div>
              <div className='lp-contact-benefit'>
                <span className='lp-check-icon'>
                  <CheckCircleIcon sx={{ fontSize: 24 }} />
                </span>
                <span>Kostenlose Test-Phase</span>
              </div>
              <div className='lp-contact-benefit'>
                <span className='lp-check-icon'>
                  <CheckCircleIcon sx={{ fontSize: 24 }} />
                </span>
                <span>Preise auf Anfrage – fair und transparent</span>
              </div>
            </div>
          </div>

          <div className='lp-contact-form-wrapper'>
            {submitted ? (
              <div className='lp-success-message'>
                <div className='lp-success-icon'>
                  <CheckCircleIcon sx={{ fontSize: 40 }} />
                </div>
                <h3>Vielen Dank!</h3>
                <p>Wir melden uns innerhalb von 24 Stunden bei Ihnen.</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className='lp-contact-form'>
                <div className='lp-form-group'>
                  <label htmlFor='name'>Name *</label>
                  <input
                    type='text'
                    id='name'
                    name='name'
                    value={contactForm.name}
                    onChange={handleChange}
                    required
                    placeholder='Max Mustermann'
                  />
                </div>

                <div className='lp-form-group'>
                  <label htmlFor='email'>E-Mail *</label>
                  <input
                    type='email'
                    id='email'
                    name='email'
                    value={contactForm.email}
                    onChange={handleChange}
                    required
                    placeholder='max@unternehmen.de'
                  />
                </div>

                <div className='lp-form-group'>
                  <label htmlFor='company'>Unternehmen *</label>
                  <input
                    type='text'
                    id='company'
                    name='company'
                    value={contactForm.company}
                    onChange={handleChange}
                    required
                    placeholder='Firma GmbH'
                  />
                </div>

                <div className='lp-form-group'>
                  <label htmlFor='message'>Nachricht (optional)</label>
                  <textarea
                    id='message'
                    name='message'
                    value={contactForm.message}
                    onChange={handleChange}
                    rows='4'
                    placeholder='Erzählen Sie uns von Ihren Anforderungen...'
                  />
                </div>

                <button
                  type='submit'
                  className='lp-btn-primary lp-btn-large'
                  disabled={submitting}
                >
                  {submitting ? 'Wird gesendet...' : 'Demo anfragen'}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  )
}

export default LandingContact

